(() => {
  const initLadiPdp = (root) => {
    if (root.dataset.ladiPdpInitialized === 'true') return;
    root.dataset.ladiPdpInitialized = 'true';

    const sticky = root.querySelector('[data-ladi-pdp-sticky]');
    const buyBox = root.querySelector('[data-ladi-pdp-buybox]');
    const mainButton = root.querySelector('[id^="ProductSubmitButton-"]');
    const stickyButton = root.querySelector('[data-ladi-pdp-sticky-button]');
    const stickyPrice = root.querySelector('[data-ladi-pdp-sticky-price]');
    const price = root.querySelector('[id^="price-"]');
    const carousel = root.querySelector('[data-ladi-pdp-carousel]');
    const dots = Array.from(root.querySelectorAll('[data-ladi-pdp-dot]'));

    if (carousel && dots.length) {
      const slides = Array.from(root.querySelectorAll('[data-ladi-pdp-slide]'));
      const setActiveDot = () => {
        if (!slides.length) return;
        const scrollLeft = carousel.scrollLeft;
        const activeIndex = slides.reduce(
          (closest, slide, index) => {
            const distance = Math.abs(slide.offsetLeft - scrollLeft - carousel.offsetLeft);
            return distance < closest.distance ? { index, distance } : closest;
          },
          { index: 0, distance: Number.POSITIVE_INFINITY }
        ).index;

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.index || 0);
          const target = slides[index];
          if (!target) return;
          carousel.scrollTo({
            left: target.offsetLeft - carousel.offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
      });

      carousel.addEventListener('scroll', () => window.requestAnimationFrame(setActiveDot), { passive: true });
      setActiveDot();
    }

    if (!sticky || !buyBox || !mainButton || !stickyButton) return;

    sticky.hidden = false;

    const syncSticky = () => {
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';

      const buttonText = mainButton.querySelector('span');
      const customSubmitLabel = mainButton.dataset.ladiPdpSubmitLabel;
      if (!stickyButton.disabled && buttonText && customSubmitLabel && buttonText.textContent.trim() !== customSubmitLabel) {
        buttonText.textContent = customSubmitLabel;
      }

      if (buttonText && buttonText.textContent.trim()) {
        stickyButton.textContent = buttonText.textContent.trim();
      }

      if (price && stickyPrice) {
        const currentPrice = price.textContent.replace(/\s+/g, ' ').trim();
        if (currentPrice) stickyPrice.textContent = currentPrice;
      }
    };

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled) return;
      mainButton.click();
    });

    const buttonObserver = new MutationObserver(syncSticky);
    buttonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (price) {
      const priceObserver = new MutationObserver(syncSticky);
      priceObserver.observe(price, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    const toggleSticky = (isVisible) => {
      sticky.classList.toggle('is-visible', isVisible && window.matchMedia('(max-width: 749px)').matches);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          toggleSticky(!entry.isIntersecting);
        },
        { threshold: 0 }
      );
      observer.observe(buyBox);
    } else {
      const onScroll = () => {
        const bounds = buyBox.getBoundingClientRect();
        toggleSticky(bounds.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    syncSticky();
  };

  const initAll = () => {
    document.querySelectorAll('[data-ladi-pdp]').forEach(initLadiPdp);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
